import { useAction } from 'shared/hooks/redux/hooks';
import { changeTab } from 'console/redux/main-actions';
import { useCallback, useEffect } from 'react';
export const useKeybind = (shown_tabs, selected_tab) => {
    const selectTab = useAction(changeTab);
    const keyupHandler = useCallback((e) => {
        if (e.target instanceof HTMLInputElement ||
            e.target instanceof HTMLTextAreaElement)
            return;
        // Если свайпер на экране, то ничего не делать
        if (document.querySelectorAll('.swipable-modal')?.length > 0)
            return;
        const target = e.target;
        if (e.code === 'ArrowLeft' && target?.tabIndex > -2) {
            const selected_index = shown_tabs.findIndex((tab) => tab.key === selected_tab.key);
            if (selected_index === -1)
                return;
            const next_key = selected_index - 1 < 0
                ? shown_tabs[shown_tabs.length - 1].key
                : shown_tabs[selected_index - 1].key;
            selectTab(next_key);
        }
        if (e.code === 'ArrowRight' && target?.tabIndex > -2) {
            const selected_index = shown_tabs.findIndex((tab) => tab.key === selected_tab.key);
            if (selected_index === -1)
                return;
            const next_key = selected_index + 1 > shown_tabs.length - 1
                ? shown_tabs[0].key
                : shown_tabs[selected_index + 1].key;
            selectTab(next_key);
        }
    }, [shown_tabs, selected_tab]);
    useEffect(() => {
        document.addEventListener('keyup', keyupHandler);
        return () => {
            document.removeEventListener('keyup', keyupHandler);
        };
    }, [keyupHandler]);
};
